module.exports = __webpack_public_path__ + "static/media/chatLoader.507e3703.gif";